/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './field.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../../app/modules/fields/directives/field-value.directive';
import * as i3 from '../../../../../../app/modules/fields/components/field/field.component';
import * as i4 from '../../../../../../app/modules/fields/services/field-form/field-form.service';
const styles_FieldComponent:any[] = [i0.styles];
export const RenderType_FieldComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_FieldComponent,data:{}});
export function View_FieldComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{fieldValueContainer:0}),(_l()(),i1.ɵeld(1,
      16777216,(null as any),(null as any),2,(null as any),(null as any),(null as any),
      (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(2,16384,[[1,
      4]],0,i2.FieldValueDirective,[i1.ViewContainerRef],(null as any),(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),[' '])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],
      (null as any),(null as any));
}
export function View_FieldComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-field',
      ([] as any[]),[[2,'not-required',(null as any)]],(null as any),(null as any),
      View_FieldComponent_0,RenderType_FieldComponent)),i1.ɵdid(1,114688,(null as any),
      0,i3.FieldComponent,[i1.ComponentFactoryResolver,i4.FieldFormService],(null as any),
      (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).isNotRequired;
    _ck(_v,0,0,currVal_0);
  });
}
export const FieldComponentNgFactory:i1.ComponentFactory<i3.FieldComponent> = i1.ɵccf('app-field',
    i3.FieldComponent,View_FieldComponent_Host_0,{editable:'editable',form:'form',
        fieldValue:'fieldValue'},{fieldValueChange:'fieldValueChange',edited:'edited'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL2ZpZWxkcy9jb21wb25lbnRzL2ZpZWxkL2ZpZWxkLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvd3d3L2RuYXRhLWNlcmYtZnJvbnQtZW5kL3JlbGVhc2VzLzIwMjAwMzI2MTYxMjMzL3NyYy9hcHAvbW9kdWxlcy9maWVsZHMvY29tcG9uZW50cy9maWVsZC9maWVsZC5jb21wb25lbnQudHMiLCJuZzovLy92YXIvd3d3L2RuYXRhLWNlcmYtZnJvbnQtZW5kL3JlbGVhc2VzLzIwMjAwMzI2MTYxMjMzL3NyYy9hcHAvbW9kdWxlcy9maWVsZHMvY29tcG9uZW50cy9maWVsZC9maWVsZC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL2ZpZWxkcy9jb21wb25lbnRzL2ZpZWxkL2ZpZWxkLmNvbXBvbmVudC50cy5GaWVsZENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxuZy1jb250YWluZXIgYXBwRmllbGRWYWx1ZT4gPC9uZy1jb250YWluZXI+XG4iLCI8YXBwLWZpZWxkPjwvYXBwLWZpZWxkPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7O2lFQ0FBO01BQUE7TUFBQSxpRUFBQTtNQUFBO01BQTRCLHlDQUFnQjs7OztvQkNBNUM7TUFBQTtxREFBQSxVQUFBO01BQUE7TUFBQTtJQUFBOztJQUFBO0lBQUEsV0FBQSxTQUFBOzs7Ozs7In0=



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/fields/components/field/field.component.ngfactory.ts